import { ArrowRight } from '@/icons/ArrowRight';
import { Pressable } from 'react-native';
import Animated, {
  type SharedValue,
  useAnimatedStyle,
  withSpring,
  withTiming
} from 'react-native-reanimated';
import { Loading } from './loading';

const AnimatedPressable = Animated.createAnimatedComponent(Pressable);

type ButtonProps = {
  flatListIndex: SharedValue<number>;
  dataLength: number;
  onLast: () => void;
  onNext: () => void;
  isLoading: boolean;
};

export function OnboardingButton({
  dataLength,
  flatListIndex,
  onLast,
  onNext,
  isLoading
}: ButtonProps) {
  const buttonAnimationStyle = useAnimatedStyle(() => {
    const isLastScreen = flatListIndex.value === dataLength - 1;
    return {
      width: isLastScreen ? withSpring(140) : withSpring(60),
      height: 60
    };
  });

  const arrowAnimationStyle = useAnimatedStyle(() => {
    const isLastScreen = flatListIndex.value === dataLength - 1;
    return {
      opacity: isLastScreen ? withTiming(0) : withTiming(1),
      transform: [
        { translateX: isLastScreen ? withTiming(100) : withTiming(0) }
      ]
    };
  });

  const textAnimationStyle = useAnimatedStyle(() => {
    const isLastScreen = flatListIndex.value === dataLength - 1;
    return {
      opacity: isLastScreen ? withTiming(1) : withTiming(0),
      transform: [
        { translateX: isLastScreen ? withTiming(0) : withTiming(-100) }
      ]
    };
  });

  const handleNextScreen = () => {
    const current = flatListIndex.get();
    const isLastScreen = current === dataLength - 1;
    if (isLastScreen) {
      onLast();
    } else {
      onNext();
    }
  };

  return (
    <AnimatedPressable
      onPress={handleNextScreen}
      className="items-center justify-center overflow-hidden rounded-full bg-lagoon-400 p-2.5"
      style={[buttonAnimationStyle]}
    >
      <Animated.Text
        className="absolute text-base font-bold text-primary"
        style={[textAnimationStyle]}
      >
        Get Started
      </Animated.Text>

      <Animated.View className="absolute" style={[arrowAnimationStyle]}>
        {isLoading ? (
          <Loading />
        ) : (
          <ArrowRight size={30} className="text-primary-foreground" />
        )}
      </Animated.View>
    </AnimatedPressable>
  );
}
